import { Button, buttonVariants } from '@/components/ui/button';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import { Abschnitt as AbschnittType } from '@/domain/mitarbeiter/features/rotationsplan/entities/Abschnitt';
import {
  faCalendarRange,
  faChevronDown,
  faChevronUp,
  faPlusLarge,
  faUser,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { Link, useParams } from 'react-router-dom';

/* eslint-disable max-lines-per-function */
export function Abschnitt({ abschnitt }: { abschnitt: AbschnittType }) {
  const { id } = useParams();
  const [isOpen, setIsOpen] = useState(true);
  const { t } = useTranslation();

  return (
    <div key={abschnitt.id} className="flex flex-col gap-5">
      <div className="mt-8 flex items-center gap-2">
        <Button variant="ghost" size="icon" onClick={() => setIsOpen(!isOpen)}>
          <FontAwesomeIcon
            className="text-neutrals-700"
            icon={isOpen ? faChevronUp : faChevronDown}
          />
        </Button>
        <div className="font-bold">
          {abschnitt.position + '. ' + abschnitt.name}
        </div>
      </div>
      <div className="flex flex-col gap-4">
        {abschnitt.stationen.map((station) =>
          station instanceof ArbeitsbereichStation ? (
            isOpen && (
              <div
                key={station.id}
                className="w-full bg-white rounded-md flex flex-col gap-3 p-4">
                <div className="flex flex-col gap-1">
                  <div className="flex gap-2 items-center">
                    <FontAwesomeIcon
                      icon={faCircle}
                      color={station.arbeitsbereich.getBorderColor()}
                    />
                    <div className="font-bold">
                      {station.arbeitsbereich.name}
                    </div>
                  </div>
                  {station.lernziele && station.lernziele.length > 0 && (
                    <div className="text-sm text-neutrals-700 line-clamp-3">
                      {station.lernziele}
                    </div>
                  )}
                </div>
                <div className="flex gap-4 items-center text-neutrals-700 text-sm">
                  <div className="flex gap-1 items-center">
                    <FontAwesomeIcon icon={faCalendarRange} />
                    {dayjs(station.von).format('DD.MM.YYYY') +
                      ' – ' +
                      dayjs(station.bis).format('DD.MM.YYYY')}
                  </div>
                  {station.bereichsleiter && (
                    <div className="flex gap-1 items-center">
                      <FontAwesomeIcon icon={faUser} />
                      {station.bereichsleiter.getName()}
                    </div>
                  )}
                </div>
              </div>
            )
          ) : (
            <div key={station.id}>Wird noch nicht angezeigt</div>
          ),
        )}
        {isOpen && (
          <div className="w-full bg-white rounded-md flex justify-start p-4">
            <Link
              to={`/mitarbeiter/rotationsplan/${id}/${abschnitt.id}/station/create`}
              className={cn(
                buttonVariants({ variant: 'ghost-primary' }),
                'flex items-center gap-2',
              )}>
              <FontAwesomeIcon icon={faPlusLarge} />
              {t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.createStation.label',
              )}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
